<template>
  <div class="code">
    <div class="code__desc">
      Dla bezpieczeństwa danych pacjenta przy każdym logowaniu konieczne jest podanie nowego kodu,
      który właśnie otrzymali Państwo na adres e-mail.
    </div>
    <div class="code__form">
      <div class="login__row code__row">
        <img src="@/assets/svg/lock.svg" alt />
        <input type="text" name="code" @blur="checkCode" @keydown.enter="handleSubmit" v-model="code" placeholder="KOD" />
        <div v-if="error" class="form__row-error form__row-error--icon">{{error}}</div>
      </div>
      <div class="login__row">
        <a :class="submitBtnClass" @click="handleSubmit">Zaloguj się</a>
      </div>
      <div class="login-actions">
        <div class="login-actions__item">
          Nie otrzymałeś nowego kodu?
          <br />
          <a href="#" @click="resendCode" class="login-actions__link">Wyślij kod ponownie</a>
          <div class="form__success" v-if="resendSuccess">{{resendSuccess}}</div>
          <div class="form__error" v-if="resendError">{{resendError}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "Code",
  data() {
    return {
      submitBtnClass: "btn",
      error: "",
      code: "",
      resendSuccess: "",
      resendError: ""
    };
  },
  computed: mapGetters({
    user: "getLoginData"
  }),
  methods: {
    checkCode() {
      this.error = "";
      !this.code ? (this.error = "Kod autoryzacyjny jest wymagany") : null;
    },
    handleSubmit() {
      this.checkCode();

      if (this.code && !this.error) {
        this.submitBtnClass = "btn spinner spinner--running";
        axios({
          method: "post",
          url: `${process.env.VUE_APP_API_URL}/login`,
          headers: {
            "Content-type": "application/json"
          },
          data: {
            id: this.user.id,
            code: this.code
          }
        })
          .then(response => {
            this.submitBtnClass = "btn spinner spinner--complete";
            this.$store.commit("saveUserToken", response.data.token);
            this.$store.commit("destroyLoginData");
            this.$store.dispatch("fetchUserDataIfLoggedIn");
            setTimeout(() => this.$router.push("/"), 1000);
          })
          .catch(err => {
            this.submitBtnClass = "btn";
            this.error =  err.response.data.message ? err.response.data.message : "Wystąpił nieznany błąd";
          });
      }
    },
    resendCode(e) {
      e.preventDefault();

      axios({
        method: "post",
        url: `${process.env.VUE_APP_API_URL}/login/resend-code`,
        headers: {
          "Content-type": "application/json"
        },
        data: {
          id: this.user.id
        }
      })
        .then(response => {
          this.resendError = "";
          this.user.id = response.data.id;
          this.resendSuccess = "Wiadomość została wysłana";
        })
        .catch(error => {
          this.resendSuccess = "";
          this.resendError = `Wystąpił błąd: ${error.response.data.message}`;
        });
    }
  }
};
</script>

<style lang="scss">
.code {
  width: 95%;
  max-width: 700px;
  margin: 30px auto;
  &__desc {
    text-align: center;
    font-size: 16px;
    h3 {
      margin-bottom: 0;
    }
    p {
      margin-top: 0;
    }
  }
  &__form {
    max-width: 300px;
    margin: auto;
    & .form__success {
      margin: 20px;
    }
    & .form__error {
      margin: 20px;
    }
  }
  &__row.login__row {
    margin: 30px 0;
  }
  &-actions {
    text-align: center;
    .btn {
      margin-top: 15px;
    }
  }
  &__section {
    max-width: 300px;
    margin: auto;
  }
  &__row {
    margin: 30px 0;
    position: relative;
    justify-content: center;
    img {
      position: absolute;
      left: 13px;
      top: 8px;
    }
  }
  &__input {
    padding: 0 0 0 40px !important;
  }
}
</style>
